import React from "react";
import { Link } from "react-router-dom";
import { Users, ArrowLeft, Home as HomeIcon, Target } from "lucide-react";
import { Seo } from "../components/Seo";

export default function About() {
  return (
    <div className="max-w-3xl mx-auto px-6 md:px-12 py-10 md:py-14">
      <Seo
        title="Om oss & Vår vision"
        description="Bakom Enkla Manualer står en utbildad nätverkstekniker med flera års erfarenhet inom IT. Vår vision: göra tekniken enkel och trygg för alla, oavsett ålder."
        path="/om-oss"
        jsonLd={{ "@context": "https://schema.org", "@type": "AboutPage", name: "Om oss & Vår vision", url: "https://enklamanualer.se/om-oss" }}
      />
      <Link to="/" data-testid="about-back" className="inline-flex items-center gap-2 text-lg font-semibold text-[#0056D2] hover:underline">
        <ArrowLeft size={22} strokeWidth={2.5} /> Tillbaka till start
      </Link>

      <h1 className="font-heading text-4xl md:text-5xl font-extrabold text-[#1A1A1A] mt-6 flex items-start gap-3">
        <Users size={44} strokeWidth={2.5} className="text-[#0056D2] shrink-0 mt-1" /> Om oss &amp; Vår vision
      </h1>

      <div className="bg-white border-2 border-gray-300 rounded-xl p-7 md:p-9 mt-8">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-[#1A1A1A] flex items-center gap-3">
          <Target size={30} strokeWidth={2.5} className="text-[#0056D2]" /> Vilka är vi?
        </h2>
        <p className="text-lg md:text-xl leading-relaxed text-[#1A1A1A] mt-5">
          Bakom Enkla Manualer står en utbildad nätverkstekniker med flera års arbetserfarenhet
          inom IT-branschen.
        </p>
        <p className="text-lg md:text-xl leading-relaxed text-[#1A1A1A] mt-4">
          Efter att ha arbetat med komplexa system insåg vi att det saknades
          något viktigt på marknaden: enkla, pedagogiska och tillgängliga instruktioner för de som
          inte är uppvuxna med tekniken.
        </p>
        <p className="text-lg md:text-xl leading-relaxed text-[#1A1A1A] mt-4">
          Vårt mål är att översätta vår expertis till ett språk som
          alla kan förstå, så att du kan känna dig trygg och självständig med dina digitala verktyg.
        </p>
        <p className="text-lg md:text-xl leading-relaxed text-[#1A1A1A] mt-5">
          För att du aldrig ska behöva fastna erbjuder vi dessutom direktkontakt med mänsklig support
          via vår livechatt. Du hittar den som en blå chattbubbla längst ner i det högra hörnet på din skärm.
        </p>
      </div>

      <div className="text-center mt-10">
        <Link to="/" className="inline-flex items-center gap-2 text-lg font-semibold text-[#0056D2] hover:underline">
          <HomeIcon size={22} strokeWidth={2.5} /> Tillbaka till start
        </Link>
      </div>
    </div>
  );
}
